module.exports = __webpack_public_path__ + "static/img/3.73e225e4.jpg";